// extracted by mini-css-extract-plugin
export default {"container":"EULA_container__jLCld"};